import CryptoJS from "crypto-js";
import defaultImg from "assets/images/defaultImg.png";

// parameter 값 가져오기
export const getParameter = (key) => {
  return new URLSearchParams(window.location.search).get(key);
};

export const setParameter = (key, value) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, "", url);
};

// value 값 가져오기
export const getElementValue = (id) => {
  return document.getElementById(id).value;
};
export const setElementValue = (id, value) => {
  document.getElementById(id).value = value;
};

// select 값 가져오기
export const getElementSelect = (id) => {
  return document.querySelector(`#${id} .selectText`).getAttribute("data-id");
};
// radio 값 가져오기
export const getElementRadio = (name) => {
  return document.querySelector(`input[name=${name}]:checked`).value;
};
export const setElementRadio = (name, value) => {
  const radio = document.querySelectorAll(`input[name="${name}"]`);
  radio.forEach((element) => {
    if (element.value === value) {
      element.checked = true;
    }
  });
};

export const resetRadioState = (name, defaultValue = 1) => {
  const radios = document.querySelectorAll(`input[name="${name}"]`);
  radios.forEach((radio) => {
    radio.checked = Number(radio.value) === defaultValue;
    const label = document.querySelector(`label[for="${radio.id}"]`);
    if (label) {
      if (Number(radio.value) === defaultValue) {
        label.classList.add("active");
      } else {
        label.classList.remove("active");
      }
    }
  });
};

// check 여부 확인
export const getElementCheck = (id) => {
  return document.getElementById(id).checked;
};
export const setElementCheck = (id, value) => {
  document.getElementById(id).checked = value;
};

// 세션 정보 가져오기
export const getSessionInfo = () => {
  const keepChk = window.localStorage.getItem("keepChk");
  let userId, userType, chanlTpcd, reptName, token;

  if (keepChk === null) {
    userId = window.sessionStorage.getItem("userId");
    userType = window.sessionStorage.getItem("userType");
    chanlTpcd = window.sessionStorage.getItem("channel");
    reptName = window.sessionStorage.getItem("reptName");
    token = window.sessionStorage.getItem("token");
  } else {
    userId = window.localStorage.getItem("userId");
    userType = window.localStorage.getItem("userType");
    chanlTpcd = window.localStorage.getItem("channel");
    reptName = window.localStorage.getItem("reptName");
    token = window.localStorage.getItem("token");
  }

  return { userId, userType, chanlTpcd, reptName, token };
};

const { token, reptName, userId, userType } = getSessionInfo();

export const getToken = () => token;
export const getReptName = () => reptName;
export const getUserId = () => userId;
export const getUserType = () => Number(userType);

// 이미지가 없을 경우
export function handleImgError(e) {
  e.target.src = defaultImg;
}

// 팝업 열기
export const openPopup = (id) => {
  document.getElementById(id).classList.remove("hide");
};
export const openPopup2 = (id) => {
  document.getElementById(id).classList.remove("d-none");
};
export const closePopup = (id) => {
  const element = document.getElementById(id); // yourDivId는 대상 div의 id입니다.
  try {
    element.querySelector(".popupContent").scrollTop = 0;
  } catch (e) {
    element.classList.add("hide");
  }
  element.classList.add("hide");
};

export const closePopup2 = (id) => {
  document.getElementById(id).classList.add("d-none");
};

// 셀렉트 버튼 이벤트
export const selectBtnEvent = (e) => {
  // 모든 셀렉트 박스 비활성화
  const selectOptionListBox = document.querySelectorAll(".selectOptionListBox");
  selectOptionListBox.forEach((element) => {
    element.style.display = "none";
  });
  // 셀렉트 텍스트 박스 클릭 시 타켓 셀렉트 박스 활성화
  if (e.target.classList.contains("selectTextBox")) {
    const targetId = e.target.getAttribute("data-href");
    const targetElement = document.getElementById(targetId);
    const listBox = document.getElementById(`${targetId}Ul`);

    const rect = targetElement.getBoundingClientRect();
    const x = rect.left;
    const y = rect.top;
    const width = rect.width;

    listBox.style.width = `${width}px`;
    listBox.style.top = `${y + 39}px`;
    listBox.style.left = `${x}px`;
    listBox.style.display = "block";
    listBox.style.padding = "0 13px";
    listBox.style.boxSizing = "border-box";
  }
};

// 셀렉트 버튼 이벤트
export const selectBtnEvent2 = (e) => {
  // 모든 셀렉트 박스 비활성화
  const select = document.querySelectorAll(".select2");
  select.forEach((element) => {
    element.classList.remove("active");
  });

  const selectOptionListBox = document.querySelectorAll(
    ".selectOptionListBox2",
  );
  selectOptionListBox.forEach((element) => {
    element.classList.add("d-none");
  });

  // 셀렉트 텍스트 박스 클릭 시 타켓 셀렉트 박스 활성화
  if (e.target.classList.contains("selectText2")) {
    const targetId = e.target.getAttribute("data-href");
    const targetElement = document.getElementById(targetId);
    const listBox = document.getElementById(`${targetId}Ul`);

    targetElement.classList.add("active");

    const rect = targetElement.getBoundingClientRect();
    const x = rect.left;
    const y = rect.top;
    const width = rect.width;

    listBox.style.width = `${width}px`;
    listBox.style.top = `${y + 39}px`;
    listBox.style.left = `${x}px`;
    listBox.classList.remove("d-none");

    const listBoxRect = listBox.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (listBoxRect.bottom > windowHeight) {
      listBox.style.top = `${y - listBoxRect.height}px`; // 위로 10px 여유 공간
    }
  }
};

// 셀렉트 박스 이벤트
export const selectBoxEvent = (e) => {
  const selectBoxList = document.querySelectorAll(".selectBox");
  selectBoxList.forEach((element) => {
    element.classList.remove("active");
  });

  if (e.target.classList.contains("selectText")) {
    const selectBox = e.target.parentNode;
    const rect = selectBox.getBoundingClientRect();
    const x = rect.left;
    const y = rect.top;
    const width = rect.width;

    selectBox.querySelector(".selectList").style.top = `${y}px`;
    selectBox.querySelector(".selectList").style.left = `${x}px`;
    selectBox.querySelector(".selectList").style.width = `${width - 22}px`;

    selectBox.classList.add("active");
  }
};

export const selectOptionEvent = (e) => {
  const selectText =
    e.target.parentNode.parentNode.querySelector(".selectText");
  const text = e.target.innerText;
  const value = e.target.getAttribute("data-id");
  selectText.innerText = text;
  selectText.setAttribute("data-id", value);
};

// 이미지 변환
export const imageChangeEvent = (
  e,
  maxSize,
  type,
  fileName,
  previewName,
  fileList,
  setFileList,
  removeFile,
  setRemoveFile,
) => {
  const file = e.target;

  // 파일 확장자 확인
  const allowedExtensions = ["jpg", "jpeg", "png", "gif"];
  const fileExtension = file.files[0].name.split(".").pop().toLowerCase();

  if (!allowedExtensions.includes(fileExtension)) {
    alert("이미지 파일만 등록할 수 있습니다.");
    return false;
  }

  // 파일 형식 변환
  const fileReader = new FileReader();
  fileReader.onload = (base64) => {
    const image = new Image();
    image.src = base64.target.result;

    image.onload = (e) => {
      // 파일 최대 사이즈에 맞춰 이미지 크기 변경
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const { width, height } = imageSizeEvent(e, maxSize);

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(e.target, 0, 0, width, height);

      // 이미지 데이터를 JPEG 형식으로 변환
      const fileInfo = canvas.toDataURL("image/jpeg", 1);

      // 파일 정보 구성
      const arr1 = file.files[0].name.split(".");
      const arr2 = fileInfo.split(",");
      const fileId = Number(file.dataset.id);
      const fileIndex = Number(file.dataset.index);

      // 중복된 fileId 제거
      const filteredFileList = fileList.filter((item) => item.id !== fileId);

      const fileImage = {
        index: fileIndex,
        id: fileId === 0 ? undefined : fileId,
        imageType: type,
        encodedFile: arr2[1],
        fileName: `${arr1[0]}_${type}`,
        fileExtension: "jpg",
        fileInfo: fileInfo,
      };

      // 업로드된 파일명 표시
      if (fileName !== "") {
        document.getElementById(fileName).value = file.files[0].name;
      }

      // 미리보기 표시
      if (previewName !== "") {
        document.getElementById(previewName).setAttribute("src", fileInfo);
      }

      // 파일 리스트에 저장
      setFileList([...filteredFileList, fileImage]);
      if (removeFile && fileId !== 0) {
        let modifyList = removeArrayByNumber(removeFile, fileId);
        setRemoveFile(modifyList);
      }
    };
  };
  fileReader.readAsDataURL(file.files[0]);
};

// 이미지 사이즈 변환
export const imageSizeEvent = (e, maxSize) => {
  let { width, height } = e.target;

  if (width > height) {
    if (width > maxSize) {
      height *= maxSize / width;
      width = maxSize;
    }
  } else {
    if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }
  }

  return { width, height };
};

// id로 배열 삭제
export const removeArrayById = (arr, idToRemove) => {
  // 배열을 순회하며 id값이 일치하지 않는 배열만 새로운 배열에 유지합니다.
  return arr.filter((subArr) => subArr.id !== idToRemove);
};
// index로 배열 삭제
export const removeArrayByIndex = (arr, idToRemove) => {
  // 배열을 순회하며 index값이 일치하지 않는 배열만 새로운 배열에 유지합니다.
  return arr.filter((subArr) => subArr.index !== idToRemove);
};
// number로 배열 삭제
export const removeArrayByNumber = (arr, idToRemove) => {
  // 배열을 순회하며 number값이 일치하지 않는 배열만 새로운 배열에 유지합니다.
  return arr.filter((subArr) => subArr !== idToRemove);
};

// 로딩 팝업창 출력
export const callLoadingEvent = (type) => {
  const loadingPopup = document.getElementById("loadingPopup");

  if (type === 1) {
    loadingPopup.classList.add("d-flex");
    loadingPopup.classList.remove("d-none");
  } else {
    loadingPopup.classList.remove("d-flex");
    loadingPopup.classList.add("d-none");
  }
};

// 셀렉트 값 변경 이벤트
export const selectEvent = (id, name, value) => {
  const selectBox = document.querySelector(`#${id} .selectText2`);
  selectBox.innerText = name;
  selectBox.setAttribute("data-id", value);
};

// 팝업 토글 이벤트
export const popupToggleEvent = (id) => {
  const popup = document.getElementById(id);
  if (!popup) return;

  popup.classList.toggle("d-none");

  // 팝업이 열렸을 경우에만 스크롤 초기화
  if (!popup.classList.contains("d-none")) {
    const content = popup.querySelector(".popupContent");
    if (content) content.scrollTop = 0;

    // 또는 전체 팝업 자체가 스크롤 대상일 경우
    popup.scrollTop = 0;
  }
};

// 암호화
export const encryptParam = (param) => {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse(
    process.env.REACT_APP_SECRET_KEY.slice(0, 16),
  );
  const IV = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV.slice(0, 16));
  const encrypted = CryptoJS.AES.encrypt(param, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString(); // Base64 문자열 반환
};

// 복호화
export const decryptParam = (encrypted) => {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse(
    process.env.REACT_APP_SECRET_KEY.slice(0, 16),
  );
  const IV = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV.slice(0, 16));
  const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return bytes.toString(CryptoJS.enc.Utf8);
};

export const getUserInfo = () => {
  const keepCheck = localStorage.getItem("keepCheck") === "true";
  const env = keepCheck
    ? localStorage.getItem("env")
    : sessionStorage.getItem("env");
  const result = decryptParam(env);
  const split = result.split(",");

  return {
    userId: split[0],
    accessToken: split[1],
    refreshToken: split[2],
  };
};

export const getShopList = () => {
  const keepCheck = localStorage.getItem("keepCheck") === "true";
  const env = keepCheck
    ? localStorage.getItem("shopList")
    : sessionStorage.getItem("shopList");
  return JSON.parse(decryptParam(env));
};

export const getCategoryList = () => {
  const keepCheck = localStorage.getItem("keepCheck") === "true";
  const storage = keepCheck ? localStorage : sessionStorage;

  try {
    const raw = storage.getItem("categoryList");

    if (!raw) return [];

    const category = JSON.parse(raw);

    return category.filter(
      (item) => item.serviceType === 1 && !item.upperCategoryId,
    );
  } catch (e) {
    console.error("카테고리 데이터 파싱 오류:", e);
    return [];
  }
};

// 리스트 분할
export const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

// 시간 텀 두기
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// 클라이언트 고유값 생성
export const generateClientId = async () => {
  let platform;
  let brandInfo = "";

  if (navigator.userAgentData) {
    // 최신 브라우저
    const uaData = navigator.userAgentData;
    platform = uaData.platform || "unknown";

    // brands 정보도 조합
    if (uaData.brands && uaData.brands.length > 0) {
      brandInfo = uaData.brands.map((b) => `${b.brand}/${b.version}`).join(",");
    }
  } else {
    // 구형 브라우저
    platform = navigator.platform || "unknown";
    brandInfo = navigator.userAgent || "";
  }

  // 조합해서 하나의 문자열 생성
  const fixedSecret = "ceo";
  const rawClientString = `${platform}-${brandInfo}-${fixedSecret}`;

  // 문자열을 해시(SHA-256)로 변환해서 고유 ID로
  const encoder = new TextEncoder();
  const data = encoder.encode(rawClientString);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

export const getcodeDataName = (code, list) => {
  const item = list.find((value) => value.code === code);
  return item ? item.name : "";
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return ""; // 날짜가 유효하지 않을 경우

  const yy = String(date.getFullYear()).slice(2); // 연도 2자리
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // 월 (0부터 시작하므로 +1)
  const dd = String(date.getDate()).padStart(2, "0"); // 일

  return `${yy}-${mm}-${dd}`;
};
